<template>
  <transition name="favorite-fade">
    <Favorite
      v-if="showFavorite && product && product.status == 'AVAILABLE'"
      ref="favorite"
      class="favorite-tag"
      :class="source === 'product-page' ? 'favorite-tag-product' : 'favorite-tag-pla'"
      :favorite="isFavorite"
      @favoriteClicked="onFavoriteClicked"
    />
  </transition>
</template>

<script>
import Favorite from './Favorite.vue';
import useFavorite from '@/compositions/useFavorite.js';
import { ref, watch } from '@vue/composition-api';

export default {
  name: 'ProductFavorite',
  components: {
    Favorite,
  },
  props: {
    showFavorite: Boolean,
    source: {
      type: String,
      required: true,
      validators(value) {
        return ['product-page', 'pla-page'].includes(value);
      },
    },
  },
  setup(props, context) {
    const isFavorite = ref(false);
    const { $store } = context.root;
    const product = $store.state.product?.product ?? {};

    const {
      state: favoritesState, //
      updateFavoriteData,
      favorites,
    } = useFavorite();

    watch(
      () => ({ favoritesState }),
      () => {
        isFavorite.value = product.hashKey in favorites.value;
      },
      { deep: true },
    );

    function onFavoriteClicked(value) {
      updateFavoriteData({
        product: {
          id: product.hashKey,
          skuNo: product.skuNo,
        },
        value,
        target: context.refs?.favorite ? context.refs.favorite.$el.querySelector('.af') : null,
      });
    }

    return {
      onFavoriteClicked,
      isFavorite,
      product,
    };
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.favorite-fade-enter-active,
.favorite-fade-leave-active {
  transition: opacity 100ms ease-out;
}

.favorite-fade-enter,
.favorite-fade-leave-to {
  opacity: 0;
}

.favorite-tag {
  position: absolute;
  top: var(--space-4);

  @media (max-width: $mobile-breakpoint - 1) {
    top: 8px;
  }

  @media (max-width: $tablet-breakpoint - 1) {
    top: 12px;
  }
}

.favorite-tag-product {
  right: var(--space-2);
}

.favorite-tag-pla {
  top: 11px;
  right: 0px;
  border-radius: 50%;
  width: 25px;
  justify-content: center;
  padding: 5px 4px 4px 5px;
}
</style>
